export class UsuarioSumario {
  IdUsuario: number;
  Nome: string;
  Cpf: string;
  NmTelefone: string;
  Email: string

  constructor(obj?: any) {
    //console.log(obj)
    if (obj) {
      this.IdUsuario = obj.IdUsuario;
      this.Nome = obj.Nome;
      this.Cpf = obj.Cpf;
      this.NmTelefone = obj.NmTelefone || ''
      this.Email = obj.Email
    }
  }
}
